<template>
    <div class="conduct">
    <div class="image-head">
      <img src="@/assets/chess.jpg" alt="inspire clubs">
    </div>
        <section class="home-cards">
        <h4>Extra-curricular Activities</h4>
        <div class="home-cards-main">
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/logo.svg" alt="bank details">
                </div>
                <div class="feature-title">
                <h5>Extra-curricular activities – 2022</h5>
                </div>
                <div class="feature-detail">
                <p> Extra-curricular activities will begin in week 2 and end in week 11 of the term. List of clubs:</p>
                <ul>
                  <li>Chess</li>
                  <li>Chinyanja</li>
                  <li>Culture</li>
                  <li>Extra Mathematics</li>
                  <li>Girl Guides</li>
                  <li>Handwriting</li>
                  <li>Information and Communication Technology</li>
                  <li>JETS</li>
                  <li>Junior Golf (Grade 3 - 7 only)</li>
                  <li>Library</li>
                </ul>
                </div>
                <p>Junior Golf will take place at the Lusaka Golf Club. Trained coaches and equipment will be available for the children. Parents will be required to pay K300.00 per term for their child to participate in this activity. The school bus will be used to transport the children to Lusaka Golf Club and back to school. Registration for this club begins on Monday 24th January, 2022 from the accounts office.</p>
            </div>
        </div>
        </section>
    </div>
</template>

<script>

export default {
  name: 'Conduct',
  components: { }
}
</script>

<style>
.conduct .home-cards .hr {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 2em;
}
.conduct .home-cards h4 {
  padding-top: 2em;
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 2px;
  padding-bottom: 4px;
  color: #fff;
}
.conduct .home-cards .home-cards-main {
  padding: 1em;
  max-width: 800px;
  margin: 10px auto;
  background-color: var(--inspire-gold);
}
.conduct .feature {
  margin: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: .5s ease all;
}
.conduct .feature:hover {
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.5);
}
.conduct .feature h5 {
  font-size: 1.8em;
  color: #fff;
  font-weight: 500;
  padding: 4px;
}
.conduct .feature p {
  color: var(--inspire-charcoal);
}
.conduct .feature .feature-img {
  width: 45px;
  margin: 5px auto;
}
.conduct .feature .feature-img.undraw {
  width: 85px;
  margin: 5px auto;
}
.conduct .feature .feature-detail {
  padding: 8px;
  font-size: 1.2em;
}
</style>
